var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5724 48.5807C38.9533 48.5807 48.1793 39.3519 48.1793 27.9678C48.1793 16.5836 38.9533 7.35486 27.5724 7.35486C16.1915 7.35486 6.96552 16.5836 6.96552 27.9678C6.96552 39.3519 16.1915 48.5807 27.5724 48.5807Z",
    stroke: "#69B5B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5724 41.7097C28.995 41.7097 30.1483 40.5561 30.1483 39.1331C30.1483 37.71 28.995 36.5565 27.5724 36.5565C26.1498 36.5565 24.9966 37.71 24.9966 39.1331C24.9966 40.5561 26.1498 41.7097 27.5724 41.7097Z",
    fill: "#69B5B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5724 31.4033V29.6855C28.7612 29.6855 29.9232 29.3329 30.9116 28.6723C31.9 28.0117 32.6703 27.0727 33.1253 25.9741C33.5802 24.8756 33.6992 23.6667 33.4673 22.5005C33.2354 21.3343 32.6629 20.263 31.8224 19.4222C30.9818 18.5814 29.9109 18.0088 28.745 17.7768C27.5791 17.5449 26.3706 17.6639 25.2724 18.119C24.1741 18.574 23.2354 19.3446 22.575 20.3333C21.9146 21.322 21.5621 22.4843 21.5621 23.6734",
    stroke: "#69B5B5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.55f832fcf89e7f1592cbc357b3da497e.svg";
export { ForwardRef as ReactComponent };